import {API_ROOT_URL} from 'envs/_current/config'
import {schema} from 'normalizr'
import {createListTransform} from './utils/createListTransform'
import {createTransform} from './utils/createTransform'

export const medalSchema = new schema.Entity(
  'medals',
  {},
  {
    idAttribute: 'id',
  }
)

export const medalAwardSchema = new schema.Entity(
  'medalAwards',
  {},
  {
    idAttribute: 'id',
  }
)

export const medal_getMedals_Api = {
  backend: `Route::get('medals/{prop}/{id}/get-medals', 'MedalController@getMedals');`,
  root: API_ROOT_URL,
  path: '/medals/:prop/:id/get-medals',
  method: 'GET',
  paramsFields: ['tags', 'active', 'sort_by', 'keyword'],
  schema: medalSchema,
  transform: createListTransform(medalSchema),
}

export const medal_getById_Api = {
  backend: `Route::get('medals/{id}/get', 'MedalController@getById');`,
  root: API_ROOT_URL,
  path: '/medals/:id/get',
  method: 'GET',
  schema: medalSchema,
  transform: createTransform(medalSchema, 'data'),
}

export const medal_createMedal_Api = {
  backend: `Route::post('medals/{prop}/{id}/create', 'MedalController@createMedal');`,
  root: API_ROOT_URL,
  path: '/medals/:prop/:id/create',
  method: 'POST',
  schema: medalSchema,
  transform: createTransform(medalSchema, 'data'),
}

export const medal_updateMedal_Api = {
  backend: `Route::post('medals/{id}/update', 'MedalController@updateMedal');`,
  root: API_ROOT_URL,
  path: '/medals/:id/update',
  method: 'POST',
  schema: medalSchema,
  transform: createTransform(medalSchema, 'data'),
}

export const medal_deleteMedal_Api = {
  backend: `Route::post('medals/{id}/delete', 'MedalController@deleteMedal');`,
  root: API_ROOT_URL,
  path: '/medals/:id/delete',
  method: 'POST',
  schema: medalSchema,
  transform: createTransform(medalSchema, 'data'),
}

export const medal_getMedalAwardById_Api = {
  backend: `Route::get('medals/medal-awards/{id}/get', 'MedalController@getMedalAwardById');`,
  root: API_ROOT_URL,
  path: '/medals/medal-awards/:id/get',
  method: 'GET',
  schema: medalAwardSchema,
  transform: createTransform(medalAwardSchema, 'data'),
}

export const medal_getMedalAwardsOfOrganization_Api = {
  backend: `Route::get('medals/organization/{id}/medal-awards/get-rewards-by-organization', 'MedalController@getMedalAwardsOfOrganization');`,
  root: API_ROOT_URL,
  path: '/medals/organization/:id/medal-awards/get-rewards-by-organization',
  method: 'GET',
  paramsFields: ['from_date', 'to_date', 'owner_type', 'sort_by', 'keyword'],
  schema: medalAwardSchema,
  transform: createListTransform(medalAwardSchema),
}


export const medal_getMyMedalRewards_Api = {
  backend: `Route::get('medals/medal-awards/{type}/get-my-rewards', 'MedalController@getMyMedalRewards');`,
  root: API_ROOT_URL,
  path: '/medals/medal-awards/:type/get-my-rewards',
  method: 'GET',
  paramsFields: ['tags', 'sort_by', 'keyword'],
  schema: medalAwardSchema,
  transform: createListTransform(medalAwardSchema),
}

export const medal_getMedalAwards_Api = {
  backend: `Route::get('medals/medal-awards/{prop}/{id}/get-rewards', 'MedalController@getMedalAwards');`,
  root: API_ROOT_URL,
  path: '/medals/medal-awards/:prop/:id/get-rewards',
  method: 'GET',
  paramsFields: ['tags', 'sort_by', 'keyword'],
  schema: medalAwardSchema,
  transform: createListTransform(medalAwardSchema),
}

export const medal_addMedalAward_Api = {
  backend: `Route::post('medals/{prop}/{id}/medal/{medal_id}/add', 'MedalController@addMedalAward');`,
  root: API_ROOT_URL,
  path: '/medals/:prop/:id/medal/:medal_id/add',
  method: 'POST',
  schema: medalAwardSchema,
  transform: createTransform(medalAwardSchema, 'data'),
}

export const medal_editMedalAward_Api = {
  backend: `Route::post('medals/medal-awards/{id}/update', 'MedalController@editMedalAward');`,
  root: API_ROOT_URL,
  path: '/medals/medal-awards/:id/update',
  method: 'POST',
  schema: medalAwardSchema,
  transform: createTransform(medalAwardSchema, 'data'),
}

export const medal_removeMedalAward_Api = {
  backend: `Route::post('medals/medal-awards/{id}/delete', 'MedalController@removeMedalAward');`,
  root: API_ROOT_URL,
  path: '/medals/medal-awards/:id/delete',
  method: 'POST',
  schema: medalAwardSchema,
  transform: createTransform(medalAwardSchema, 'data'),
}

export const medal_setMedalAwardVisible_Api = {
  backend: `Route::post('medals/medal-awards/{medal_id}/set-visible-award', 'MedalController@setMedalAwardVisible');`,
  root: API_ROOT_URL,
  path: '/medals/medal-awards/:medal_id/set-visible-award',
  method: 'POST',
  schema: medalAwardSchema,
  transform: createTransform(medalAwardSchema, 'data'),
}
